import { useEffect, useState } from "react";
import { IoIosAdd } from "react-icons/io";
import Option from "./Option";
import axios from "axios";
import axoisConfigUtil from "../../../utils/AxoisConfigUtil";
import { Box, Button } from "@chakra-ui/react";
import projectConstants from "../../../constants/ProjectConstants";

const MAX_OPTIONS = projectConstants.MAX_OPTIONS_PER_PROJECT;

export default function Part({
  project,
  part,
  t,
  enabledTypes,
  setProject,
  activePart,
  setPreviewOptions,
}) {
  const [options, setOptions] = useState([]);
  const [addOptionLoading, setAddOptionLoading] = useState(-1);

  useEffect(() => {
    const realOptions = part?.options || [];
    const emptySlots = Array(MAX_OPTIONS).fill({});
    setOptions([
      ...realOptions,
      ...emptySlots.slice(0, MAX_OPTIONS - realOptions.length),
    ]);
    setPreviewOptions(realOptions);
  }, [part]);

  const handleNewOption = async (index) => {
    setAddOptionLoading(index);
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/options`,
        {
          text: t("building.buttonText"),
          part_id: activePart,
          option_category_id: enabledTypes.find((type) => type.name === "COPY")
            .id,
          copy: t("building.copyableText"),
        },
        axoisConfigUtil.getHeadersWithLangAndToken()
      )
      .then(function (response) {
        setAddOptionLoading(-1);
        const newOption = response.data.option;

        setOptions((prev) => {
          const realOptions = [
            ...prev.filter((opt) => Object.keys(opt).length > 0),
            newOption,
          ];
          const emptySlots = Array(MAX_OPTIONS).fill({});
          return [
            ...realOptions,
            ...emptySlots.slice(0, MAX_OPTIONS - realOptions.length),
          ];
        });

        setPreviewOptions((prev) => [...prev, newOption]);

        setProject((prev) => {
          const parts = prev.parts.map((p) => {
            if (p.id === activePart) {
              if (p.hasOwnProperty("options")) {
                p.options = [...p.options, newOption];
              } else {
                p.options = [newOption];
              }
            }
            return p;
          });
          return {
            parts,
            ...prev,
          };
        });
      })
      .catch(function (error) {
        setAddOptionLoading(-1);
        console.log(error);
      });
  };

  return (
    <>
      <Box w='auto' m='2'>
        <p className='w-32 text-lg my-5'>{t("building.buttons")}</p>
        <div className='flex flex-col gap-4'>
          {options.map((opt, index) =>
            Object.keys(opt).length ? (
              <Option
                key={opt.id || index}
                t={t}
                project={project}
                option={opt}
                options={options}
                enabledTypes={enabledTypes}
                activePart={activePart}
                setOptions={setOptions}
                setProject={setProject}
                setPreviewOptions={setPreviewOptions}
              />
            ) : (
              <AddButton
                key={index}
                isLoading={addOptionLoading === index}
                handleNewOption={() => handleNewOption(index)}
                t={t}
              />
            )
          )}
        </div>
      </Box>
    </>
  );
}

const AddButton = ({ isLoading, handleNewOption, t }) => {
  return (
    <Button
      background='transparent'
      border='2px dashed #00bcee'
      width='500px'
      height='10'
      color='#00bcee'
      _disabled={{
        bg: "#00bcee",
        _hover: {
          bg: "#00bcee",
          opacity: "0.4",
          cursor: "not-allowed",
        },
      }}
      _loading={{
        bg: "white",
        _hover: {
          bg: "white",
          cursor: "not-allowed",
        },
      }}
      rounded={"full"}
      fontWeight={"light"}
      className='flex items-center gap-2'
      onClick={handleNewOption}
      isLoading={isLoading}
    >
      <IoIosAdd className='text-3xl' />
    </Button>
  );
};
